var R = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function X(i) {
  if (i.__esModule) return i;
  var f = i.default;
  if (typeof f == "function") {
    var c = function o() {
      return this instanceof o ? Reflect.construct(f, arguments, this.constructor) : f.apply(this, arguments);
    };
    c.prototype = f.prototype;
  } else c = {};
  return Object.defineProperty(c, "__esModule", { value: !0 }), Object.keys(i).forEach(function(o) {
    var E = Object.getOwnPropertyDescriptor(i, o);
    Object.defineProperty(c, o, E.get ? E : {
      enumerable: !0,
      get: function() {
        return i[o];
      }
    });
  }), c;
}
var V = { exports: {} };
function k(i) {
  throw new Error('Could not dynamically require "' + i + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var U = { exports: {} };
const z = {}, j = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: z
}, Symbol.toStringTag, { value: "Module" })), $ = /* @__PURE__ */ X(j);
var H;
function G() {
  return H || (H = 1, function(i, f) {
    (function(c, o) {
      i.exports = o();
    })(R, function() {
      var c = c || function(o, E) {
        var l;
        if (typeof window < "u" && window.crypto && (l = window.crypto), typeof self < "u" && self.crypto && (l = self.crypto), typeof globalThis < "u" && globalThis.crypto && (l = globalThis.crypto), !l && typeof window < "u" && window.msCrypto && (l = window.msCrypto), !l && typeof R < "u" && R.crypto && (l = R.crypto), !l && typeof k == "function")
          try {
            l = $;
          } catch {
          }
        var Y = function() {
          if (l) {
            if (typeof l.getRandomValues == "function")
              try {
                return l.getRandomValues(new Uint32Array(1))[0];
              } catch {
              }
            if (typeof l.randomBytes == "function")
              try {
                return l.randomBytes(4).readInt32LE();
              } catch {
              }
          }
          throw new Error("Native crypto module could not be used to get secure random number.");
        }, S = Object.create || /* @__PURE__ */ function() {
          function t() {
          }
          return function(n) {
            var e;
            return t.prototype = n, e = new t(), t.prototype = null, e;
          };
        }(), y = {}, A = y.lib = {}, d = A.Base = /* @__PURE__ */ function() {
          return {
            /**
             * Creates a new object that inherits from this object.
             *
             * @param {Object} overrides Properties to copy into the new object.
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         field: 'value',
             *
             *         method: function () {
             *         }
             *     });
             */
            extend: function(t) {
              var n = S(this);
              return t && n.mixIn(t), (!n.hasOwnProperty("init") || this.init === n.init) && (n.init = function() {
                n.$super.init.apply(this, arguments);
              }), n.init.prototype = n, n.$super = this, n;
            },
            /**
             * Extends this object and runs the init method.
             * Arguments to create() will be passed to init().
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var instance = MyType.create();
             */
            create: function() {
              var t = this.extend();
              return t.init.apply(t, arguments), t;
            },
            /**
             * Initializes a newly created object.
             * Override this method to add some logic when your objects are created.
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         init: function () {
             *             // ...
             *         }
             *     });
             */
            init: function() {
            },
            /**
             * Copies properties into this object.
             *
             * @param {Object} properties The properties to mix in.
             *
             * @example
             *
             *     MyType.mixIn({
             *         field: 'value'
             *     });
             */
            mixIn: function(t) {
              for (var n in t)
                t.hasOwnProperty(n) && (this[n] = t[n]);
              t.hasOwnProperty("toString") && (this.toString = t.toString);
            },
            /**
             * Creates a copy of this object.
             *
             * @return {Object} The clone.
             *
             * @example
             *
             *     var clone = instance.clone();
             */
            clone: function() {
              return this.init.prototype.extend(this);
            }
          };
        }(), O = A.WordArray = d.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of 32-bit words.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.create();
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
           */
          init: function(t, n) {
            t = this.words = t || [], n != E ? this.sigBytes = n : this.sigBytes = t.length * 4;
          },
          /**
           * Converts this word array to a string.
           *
           * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
           *
           * @return {string} The stringified word array.
           *
           * @example
           *
           *     var string = wordArray + '';
           *     var string = wordArray.toString();
           *     var string = wordArray.toString(CryptoJS.enc.Utf8);
           */
          toString: function(t) {
            return (t || T).stringify(this);
          },
          /**
           * Concatenates a word array to this word array.
           *
           * @param {WordArray} wordArray The word array to append.
           *
           * @return {WordArray} This word array.
           *
           * @example
           *
           *     wordArray1.concat(wordArray2);
           */
          concat: function(t) {
            var n = this.words, e = t.words, s = this.sigBytes, a = t.sigBytes;
            if (this.clamp(), s % 4)
              for (var u = 0; u < a; u++) {
                var I = e[u >>> 2] >>> 24 - u % 4 * 8 & 255;
                n[s + u >>> 2] |= I << 24 - (s + u) % 4 * 8;
              }
            else
              for (var p = 0; p < a; p += 4)
                n[s + p >>> 2] = e[p >>> 2];
            return this.sigBytes += a, this;
          },
          /**
           * Removes insignificant bits.
           *
           * @example
           *
           *     wordArray.clamp();
           */
          clamp: function() {
            var t = this.words, n = this.sigBytes;
            t[n >>> 2] &= 4294967295 << 32 - n % 4 * 8, t.length = o.ceil(n / 4);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {WordArray} The clone.
           *
           * @example
           *
           *     var clone = wordArray.clone();
           */
          clone: function() {
            var t = d.clone.call(this);
            return t.words = this.words.slice(0), t;
          },
          /**
           * Creates a word array filled with random bytes.
           *
           * @param {number} nBytes The number of random bytes to generate.
           *
           * @return {WordArray} The random word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.random(16);
           */
          random: function(t) {
            for (var n = [], e = 0; e < t; e += 4)
              n.push(Y());
            return new O.init(n, t);
          }
        }), L = y.enc = {}, T = L.Hex = {
          /**
           * Converts a word array to a hex string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The hex string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
           */
          stringify: function(t) {
            for (var n = t.words, e = t.sigBytes, s = [], a = 0; a < e; a++) {
              var u = n[a >>> 2] >>> 24 - a % 4 * 8 & 255;
              s.push((u >>> 4).toString(16)), s.push((u & 15).toString(16));
            }
            return s.join("");
          },
          /**
           * Converts a hex string to a word array.
           *
           * @param {string} hexStr The hex string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
           */
          parse: function(t) {
            for (var n = t.length, e = [], s = 0; s < n; s += 2)
              e[s >>> 3] |= parseInt(t.substr(s, 2), 16) << 24 - s % 8 * 4;
            return new O.init(e, n / 2);
          }
        }, h = L.Latin1 = {
          /**
           * Converts a word array to a Latin1 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Latin1 string.
           *
           * @static
           *
           * @example
           *
           *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
           */
          stringify: function(t) {
            for (var n = t.words, e = t.sigBytes, s = [], a = 0; a < e; a++) {
              var u = n[a >>> 2] >>> 24 - a % 4 * 8 & 255;
              s.push(String.fromCharCode(u));
            }
            return s.join("");
          },
          /**
           * Converts a Latin1 string to a word array.
           *
           * @param {string} latin1Str The Latin1 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
           */
          parse: function(t) {
            for (var n = t.length, e = [], s = 0; s < n; s++)
              e[s >>> 2] |= (t.charCodeAt(s) & 255) << 24 - s % 4 * 8;
            return new O.init(e, n);
          }
        }, r = L.Utf8 = {
          /**
           * Converts a word array to a UTF-8 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-8 string.
           *
           * @static
           *
           * @example
           *
           *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
           */
          stringify: function(t) {
            try {
              return decodeURIComponent(escape(h.stringify(t)));
            } catch {
              throw new Error("Malformed UTF-8 data");
            }
          },
          /**
           * Converts a UTF-8 string to a word array.
           *
           * @param {string} utf8Str The UTF-8 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
           */
          parse: function(t) {
            return h.parse(unescape(encodeURIComponent(t)));
          }
        }, _ = A.BufferedBlockAlgorithm = d.extend({
          /**
           * Resets this block algorithm's data buffer to its initial state.
           *
           * @example
           *
           *     bufferedBlockAlgorithm.reset();
           */
          reset: function() {
            this._data = new O.init(), this._nDataBytes = 0;
          },
          /**
           * Adds new data to this block algorithm's buffer.
           *
           * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
           *
           * @example
           *
           *     bufferedBlockAlgorithm._append('data');
           *     bufferedBlockAlgorithm._append(wordArray);
           */
          _append: function(t) {
            typeof t == "string" && (t = r.parse(t)), this._data.concat(t), this._nDataBytes += t.sigBytes;
          },
          /**
           * Processes available data blocks.
           *
           * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
           *
           * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
           *
           * @return {WordArray} The processed data.
           *
           * @example
           *
           *     var processedData = bufferedBlockAlgorithm._process();
           *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
           */
          _process: function(t) {
            var n, e = this._data, s = e.words, a = e.sigBytes, u = this.blockSize, I = u * 4, p = a / I;
            t ? p = o.ceil(p) : p = o.max((p | 0) - this._minBufferSize, 0);
            var N = p * u, v = o.min(N * 4, a);
            if (N) {
              for (var g = 0; g < N; g += u)
                this._doProcessBlock(s, g);
              n = s.splice(0, N), e.sigBytes -= v;
            }
            return new O.init(n, v);
          },
          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = bufferedBlockAlgorithm.clone();
           */
          clone: function() {
            var t = d.clone.call(this);
            return t._data = this._data.clone(), t;
          },
          _minBufferSize: 0
        });
        A.Hasher = _.extend({
          /**
           * Configuration options.
           */
          cfg: d.extend(),
          /**
           * Initializes a newly created hasher.
           *
           * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
           *
           * @example
           *
           *     var hasher = CryptoJS.algo.SHA256.create();
           */
          init: function(t) {
            this.cfg = this.cfg.extend(t), this.reset();
          },
          /**
           * Resets this hasher to its initial state.
           *
           * @example
           *
           *     hasher.reset();
           */
          reset: function() {
            _.reset.call(this), this._doReset();
          },
          /**
           * Updates this hasher with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {Hasher} This hasher.
           *
           * @example
           *
           *     hasher.update('message');
           *     hasher.update(wordArray);
           */
          update: function(t) {
            return this._append(t), this._process(), this;
          },
          /**
           * Finalizes the hash computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The hash.
           *
           * @example
           *
           *     var hash = hasher.finalize();
           *     var hash = hasher.finalize('message');
           *     var hash = hasher.finalize(wordArray);
           */
          finalize: function(t) {
            t && this._append(t);
            var n = this._doFinalize();
            return n;
          },
          blockSize: 16,
          /**
           * Creates a shortcut function to a hasher's object interface.
           *
           * @param {Hasher} hasher The hasher to create a helper for.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
           */
          _createHelper: function(t) {
            return function(n, e) {
              return new t.init(e).finalize(n);
            };
          },
          /**
           * Creates a shortcut function to the HMAC's object interface.
           *
           * @param {Hasher} hasher The hasher to use in this HMAC helper.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
           */
          _createHmacHelper: function(t) {
            return function(n, e) {
              return new P.HMAC.init(t, e).finalize(n);
            };
          }
        });
        var P = y.algo = {};
        return y;
      }(Math);
      return c;
    });
  }(U)), U.exports;
}
(function(i, f) {
  (function(c, o) {
    i.exports = o(G());
  })(R, function(c) {
    return c.enc.Hex;
  });
})(V);
var q = { exports: {} };
(function(i, f) {
  (function(c, o) {
    i.exports = o(G());
  })(R, function(c) {
    return function(o) {
      var E = c, l = E.lib, Y = l.WordArray, S = l.Hasher, y = E.algo, A = [], d = [];
      (function() {
        function T(P) {
          for (var t = o.sqrt(P), n = 2; n <= t; n++)
            if (!(P % n))
              return !1;
          return !0;
        }
        function h(P) {
          return (P - (P | 0)) * 4294967296 | 0;
        }
        for (var r = 2, _ = 0; _ < 64; )
          T(r) && (_ < 8 && (A[_] = h(o.pow(r, 1 / 2))), d[_] = h(o.pow(r, 1 / 3)), _++), r++;
      })();
      var O = [], L = y.SHA256 = S.extend({
        _doReset: function() {
          this._hash = new Y.init(A.slice(0));
        },
        _doProcessBlock: function(T, h) {
          for (var r = this._hash.words, _ = r[0], P = r[1], t = r[2], n = r[3], e = r[4], s = r[5], a = r[6], u = r[7], I = 0; I < 64; I++) {
            if (I < 16)
              O[I] = T[h + I] | 0;
            else {
              var p = O[I - 15], N = (p << 25 | p >>> 7) ^ (p << 14 | p >>> 18) ^ p >>> 3, v = O[I - 2], g = (v << 15 | v >>> 17) ^ (v << 13 | v >>> 19) ^ v >>> 10;
              O[I] = N + O[I - 7] + g + O[I - 16];
            }
            var m = e & s ^ ~e & a, M = _ & P ^ _ & t ^ P & t, x = (_ << 30 | _ >>> 2) ^ (_ << 19 | _ >>> 13) ^ (_ << 10 | _ >>> 22), W = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25), D = u + W + m + d[I] + O[I], K = x + M;
            u = a, a = s, s = e, e = n + D | 0, n = t, t = P, P = _, _ = D + K | 0;
          }
          r[0] = r[0] + _ | 0, r[1] = r[1] + P | 0, r[2] = r[2] + t | 0, r[3] = r[3] + n | 0, r[4] = r[4] + e | 0, r[5] = r[5] + s | 0, r[6] = r[6] + a | 0, r[7] = r[7] + u | 0;
        },
        _doFinalize: function() {
          var T = this._data, h = T.words, r = this._nDataBytes * 8, _ = T.sigBytes * 8;
          return h[_ >>> 5] |= 128 << 24 - _ % 32, h[(_ + 64 >>> 9 << 4) + 14] = o.floor(r / 4294967296), h[(_ + 64 >>> 9 << 4) + 15] = r, T.sigBytes = h.length * 4, this._process(), this._hash;
        },
        clone: function() {
          var T = S.clone.call(this);
          return T._hash = this._hash.clone(), T;
        }
      });
      E.SHA256 = S._createHelper(L), E.HmacSHA256 = S._createHmacHelper(L);
    }(Math), c.SHA256;
  });
})(q);
const J = (i, f, c) => c === "subflow" ? "https://subflow.beta.petplate.com" : "https://beta.petplate.com", Q = (i, f, c, o) => {
  const E = "beta";
  return o ? `https://${i}-${c}-${E}-${o}.herokuapp.com` : `https://${i}-${c}-${E}.herokuapp.com`;
}, w = (i, f, c, o, E) => [Q(i, f, c, o), E].filter((l) => l).join(":"), b = (i, f, c, o) => [J(i, f, c), o].filter((E) => E).join(":"), Z = (i) => `https://${i}`, tt = (i, f) => f, nt = (i, f) => {
  var o;
  return `https://admin.shopify.com/store/${(o = i == null ? void 0 : i.split(".")) == null ? void 0 : o[0]}/apps/${f}`;
}, B = "platform", C = "localhost", lt = "production", ut = "beta", ft = "beta", Et = "", It = process.env.HEROKU_PR_NUMBER, pt = null, et = null, Ot = null, Pt = "staging", rt = null, ot = null, st = null, it = null, Tt = null, ct = null, ht = null, dt = !1, vt = null, At = null, St = null, yt = null, Lt = null, Nt = null, Rt = null, gt = null, Bt = null, Ct = null, Yt = null, Ut = null, wt = null, Dt = "GfTq8v8hwzxo7wHOAL1IqORPGbsJUXF8nJspLEGV", Ht = null, Gt = null, bt = null, F = "petplate-v2.myshopify.com", Ft = "5720771139ed68eac361fcc99ef7de3e", mt = "2024-10", Mt = "GTM-KJNPGK2C", xt = "G-ZVE7PQY67W", Wt = null, Kt = "2024-10", Xt = "US", Vt = "EN", kt = Z(F), zt = null, jt = process.env.SHOPIFY_APP_NAME, $t = null, _t = null, qt = null, Jt = null, Qt = null, Zt = "9e0964421a455ca62fa4fffa48767b35f930635ed143e4b9f3030e3a39b14f57", tn = "javascript-nextjs", nn = "petplate", en = null, rn = null, on = "6Lf8KJopAAAAAHp6VMFsFjOjEy9m0NLsIkG-llH3", sn = "6Lf8KJopAAAAAIW99HnsO7Kz2zMmFU9sV9zpKwRi", cn = process.env.SKIP_SUBFLOW_CALCULATING_STEP === "true", _n = w(
  B,
  C,
  "cms",
  process.env.ADMIN_APP_SUFFIX,
  rt
), at = w(
  B,
  C,
  "api",
  process.env.API_APP_SUFFIX,
  et
), an = w(
  B,
  C,
  "graphql",
  process.env.GRAPHQL_APP_SUFFIX,
  it
), ln = b(B, C, "web", ot), un = b(B, C, "subflow", st), fn = tt(ct, at), En = nt(F, _t);
export {
  rt as ADMIN_PORT,
  _n as ADMIN_URL,
  ct as API_NGROK_HOST,
  et as API_PORT,
  at as API_URL,
  ut as DOMAIN_PREFIX,
  lt as ENV,
  xt as GOOGLE_ANALYTICS_MEASUREMENT_ID,
  sn as GOOGLE_RECAPTCHA_SECRET_KEY,
  it as GRAPHQL_PORT,
  an as GRAPHQL_URL,
  Mt as GTM_CONTAINER_ID,
  pt as HEROKU_BRANCH,
  It as HEROKU_PR_NUMBER,
  vt as KLAVIYO_API_KEY,
  Wt as KLAVIYO_SITE_ID,
  Ot as MAINTENANCE_MODE,
  Tt as MONGODB_URI,
  bt as NEXT_PUBLIC_AISLE_WIDGET_ID,
  Pt as NEXT_PUBLIC_CLIENT_WEBHOOK_NAMESPACE,
  on as NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY,
  At as NEXT_PUBLIC_KLAVIYO_API_KEY,
  Jt as NEXT_PUBLIC_SENTRY_DSN,
  Gt as NEXT_PUBLIC_STOREPOINT_MAP_ID,
  Dt as NEXT_PUBLIC_YOTPO_APP_KEY,
  yt as NEXT_PUBLIC_YOTPO_LOYALTY_JS_SDK_ID,
  St as NEXT_PUBLIC_YOTPO_LOYALTY_PAGE_BANNER_WIDGET_ID,
  Nt as NEXT_PUBLIC_YOTPO_LOYALTY_PAGE_EARNING_POINTS_WIDGET_ID,
  Lt as NEXT_PUBLIC_YOTPO_LOYALTY_PAGE_MY_ACTIVITY_WIDGET_ID,
  Rt as NEXT_PUBLIC_YOTPO_LOYALTY_PAGE_REDEEM_POINTS_WIDGET_ID,
  Bt as NEXT_PUBLIC_YOTPO_LOYALTY_PAGE_REFER_FRIENDS_WIDGET_ID,
  gt as NEXT_PUBLIC_YOTPO_LOYALTY_PAGE_VIP_TIERS_WIDGET_ID,
  Ct as NEXT_PUBLIC_YOTPO_LOYALTY_REDEMPTION_200_POINTS_ID,
  Yt as NEXT_PUBLIC_YOTPO_LOYALTY_REDEMPTION_400_POINTS_ID,
  Ut as NEXT_PUBLIC_YOTPO_LOYALTY_REDEMPTION_600_POINTS_ID,
  wt as NEXT_PUBLIC_YOTPO_LOYALTY_REDEMPTION_800_POINTS_ID,
  Ht as NEXT_PUBLIC_YOTPO_REFER_A_FRIEND_PAGE_WIDGET_ID,
  en as SENDGRID_API_KEY,
  rn as SENDGRID_DOMAIN,
  Zt as SENTRY_AUTH_TOKEN,
  Qt as SENTRY_DSN,
  nn as SENTRY_ORG,
  tn as SENTRY_PROJECT,
  En as SHOPIFY_ADMIN_URL,
  ht as SHOPIFY_API_KEY,
  mt as SHOPIFY_API_VERSION,
  $t as SHOPIFY_APP_CLIENT_ID,
  jt as SHOPIFY_APP_NAME,
  _t as SHOPIFY_APP_NS,
  Xt as SHOPIFY_COUNTRY_ISO_CODE,
  F as SHOPIFY_CUSTOM_DOMAIN,
  dt as SHOPIFY_DEV_SIDENAV,
  Vt as SHOPIFY_LANGUAGE_ISO_CODE,
  Ft as SHOPIFY_STOREFRONT_ACCESS_TOKEN,
  Kt as SHOPIFY_STOREFRONT_API_VERSION,
  kt as SHOPIFY_URL,
  qt as SHOW_PRICE_CHANGE_FEATURE,
  cn as SKIP_SUBFLOW_CALCULATING_STEP,
  zt as STRIPE_PUBLISHABLE_KEY,
  st as SUBFLOW_PORT,
  un as SUBFLOW_URL,
  ft as VERCEL_GIT_COMMIT_REF,
  Et as VERCEL_GIT_PULL_REQUEST_ID,
  fn as WEBHOOK_URL,
  ot as WEB_PORT,
  ln as WEB_URL
};
